import React from "react";
import { motion } from "framer-motion";

// import { MapPin } from "lucide-react";
// import hub1 from "../../assets/images/c878f3a350dd16a30849242dec2c261bee746b75.jpg";
// import hub2 from "../../assets/images/a3447e781a72649050b3dd3fd32328b8c1c8ab2.jpg";
// import hub3 from "../../assets/images/4fa7a0990931ae84ea1911a087e63e09a2e03ecc.jpg";

// Hubs data – currently commented out until physical hubs launch
// const hubs = [
//   {
//     id: 1,
//     title: "Rhodes Box Lekki",
//     location: "Lekki, Lagos",
//     address: "26 Akin Leigh Crescent, Off Admiralty Way, Lekki, Lagos.",
//     image: hub1,
//   },
//   {
//     id: 2,
//     title: "Rhodes Box Lekki",
//     location: "Lekki, Lagos",
//     address: "26 Akin Leigh Crescent, Off Admiralty Way, Lekki, Lagos.",
//     image: hub2,
//   },
//   {
//     id: 3,
//     title: "Rhodes Box Lekki",
//     location: "Lekki, Lagos",
//     address: "26 Akin Leigh Crescent, Off Admiralty Way, Lekki, Lagos.",
//     image: hub3,
//   },
// ];

const Hubs = () => {
  return (
    <section className="bg-[#f8faff] py-20 px-6 font-sans">
      <div className="max-w-4xl mx-auto text-center">

        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <h2 className="text-gray-900 text-3xl md:text-4xl font-bold mb-4 tracking-tight">
            Peer2Learn Hubs
          </h2>

          <p className="text-gray-500 text-lg md:text-xl font-light max-w-2xl mx-auto">
            Our physical learning hubs are <span className="text-indigo-600 font-semibold">coming soon!</span> 
            Get ready to experience spaces designed for creativity, collaboration, and innovation.
          </p>
        </motion.div>

        {/* Placeholder / Marketing Message */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="mt-8 p-12 bg-white/10 border border-gray-200 rounded-2xl shadow-lg text-gray-700"
        >
          <h3 className="text-xl md:text-2xl font-semibold mb-2">
            Physical Classes Coming Soon!
          </h3>
          <p className="text-gray-500">
            Stay tuned! Peer2Learn Hubs will bring you inspiring environments for learning, collaboration, and personal growth. 
            Sign up for updates and be among the first to experience it.
          </p>
        </motion.div>

        {/* The actual hub list is commented out until launch */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {hubs.map((hub) => (
            <motion.div key={hub.id}>...</motion.div>
          ))}
        </div> */}

      </div>
    </section>
  );
};

export default Hubs;